module.exports = __webpack_public_path__ + "static/media/gM3.035dc3e9.jpg";